import { whatIsMode } from "../../../Common/ts/commonTools";
import MainPage from "../Page/MainPage/MainPage";
import Textarea from "../Textarea/Textarea";

const ErrorBoundariesPage = (
    {
        error
    }:{
        error: Error;
    }
) => {
    return(
        <MainPage title={"에러발생!"}>
            {
                whatIsMode().is_not_product_mode_safe
                &&  <Textarea
                        value={error.message}
                        readOnly
                    />
            }
        </MainPage>
    )
}

export default ErrorBoundariesPage;